import React from "react";

const ProductCategories = () => {
  return (
    <>
      <section className="static-sections py-0 py-lg-5 bg-white">
        <div className="container">

          {/* Section 1 */}
          <div className="row align-items-center mb-3 mb-lg-5">
            {/* Left side: Heading, paragraph, and stats */}
            <div className="col-lg-6">
              <h1 className="display-4 text-theme-dark text-theme-dark responsive-main-heading">Discover Elly Decor</h1>
              <p className="lead text-theme-dark">
                At Elly Decor, we believe in transforming spaces with our exquisite
                home furnishings. Our mission is to provide high-quality, stylish,
                and affordable products that enhance the beauty and comfort of every home.
              </p>

              <div className="row mt-4">
                <div className="col-6 mb-3">
                  <h4 className="text-theme-dark">100 years</h4>
                  <p className="text-theme-dark">Years of experience in the home decor industry.</p>
                </div>
                <div className="col-6 mb-3">
                  <h4 className="text-theme-dark">1000 satisfied customers</h4>
                  <p className="text-theme-dark">We prioritize customer satisfaction, ensuring every client leaves happy.</p>
                </div>
                <div className="col-6 mb-3">
                  <h4 className="text-theme-dark mb-0">15 design awards</h4>
                  <p className="text-theme-dark">Our innovative designs have earned us numerous accolades in the industry.</p>
                </div>
                <div className="col-6 mb-3">
                  <h4 className="text-theme-dark mb-0">10 team members</h4>
                  <p className="text-theme-dark">Our dedicated team is committed to providing exceptional service and support.</p>
                </div>
              </div>
            </div>

            {/* Right side: Image */}
            <div className="col-lg-6">
              <img
                src="/images/product/prd1.webp" 
                alt="Elly Decor Display"
                className="img-fluid rounded"
              />
            </div>
          </div>


          {/* Section 2 */}
          <div className="row align-items-center mb-2 mb-lg-5 mt-2">
            <div className="col-lg-6">
              <img src="/images/product/prd2.webp" alt="Curtain Fabrics" className="img-fluid rounded" />
            </div>
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3 text-theme-dark responsive-main-heading mt-3 mt-lg-0">Discover the Perfect Curtain Fabrics at Elly Decor</h2>
              <p className="mb-4 text-theme-dark">
                Explore our extensive collection of curtain fabrics, available in various colors, patterns, and textures.
                Whether you prefer sheer, blackout, or decorative fabrics, we have something to suit every style and need.
                Visit us today!
              </p>
              <ul className="list-style-disc">
                <li className="mb-2 text-theme-dark">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Wide variety of styles to match any interior decor.
                </li>
                <li className="mb-2 text-theme-dark">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  High-quality materials that ensure durability and longevity.
                </li>
                <li className="mb-2 text-theme-dark">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Customizable options available for a perfect fit.
                </li>
              </ul>
            </div>

          </div>


          {/* Section 3 */}
          <div className="row align-items-center mb-3 mb-lg-5 mt-2">
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3 text-theme-dark responsive-main-heading">Revitalize Your Sofa with Elly Decor's Exquisite Upholstery</h2>
              <p className="mb-4 text-theme-dark">
                Discover the perfect sofa upholstery at Elly Decor. Our selection features a range of materials and designs, allowing you to refresh your living space with ease. Choose from luxurious fabrics to durable options that suit your lifestyle.
              </p>
              <ul className="list-style-disc">
                <li className="mb-2 text-theme-dark">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Transform your old furniture into a stunning centerpiece.
                </li>
                <li className="mb-2 text-theme-dark">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Choose from a variety of textures and colors.
                </li>
                <li className="mb-2 text-theme-dark">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Expert advice available for selecting the right upholstery.
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <img src="/images/product/prd3.webp" alt="Curtain Fabrics" className="img-fluid rounded" />
            </div>
          </div>

          {/* Section 4 */}
          <div className="row align-items-center mb-5 mt-2">
            <div className="col-lg-6">
              <img
                src="/images/product/prd4.webp"
                alt="Elly Decor Display"
                className="img-fluid rounded"
              />
            </div>
            {/* Left side: Heading, paragraph, and stats */}
            <div className="col-lg-6">
              <h1 className="display-4 text-theme-dark responsive-main-heading mt-3 mt-lg-0">Elevate Your Space with Stylish Cushions & Accessories</h1>
              <p className="lead text-theme-dark">
                Discover our curated collection of cushions and home decor accessories at Elly Decor. From plush cushions to elegant vases, we offer everything you need to add the perfect finishing touches to your home. Explore our range today!
              </p>

              <div className="row mt-4">
                <div className="col-6 mb-3">
                  <h4 className="text-theme-dark">200+</h4>
                  <p className="text-theme-dark">Unique cushion designs to match any interior style. </p>
                </div>
                <div className="col-6 mb-3">
                  <h4 className="text-theme-dark">150+</h4>
                  <p className="text-theme-dark"> Home decor accessories sourced from top designers. </p>
                </div>

              </div>
            </div>

            {/* Right side: Image */}

          </div>

          {/* Section 5 */}
          <div className="row align-items-center mb-3 mb-lg-5 mt-2 impSec p-1 p-lg-5">
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3 .text-theme-light responsive-main-heading">Transform Your Space with Elly Decor Wallpapers</h2>
              <p className="mb-4 .text-theme-light">
                Discover our exquisite wallpaper collection at Elly Decor, designed to revitalize any room. From classic patterns to modern textures, find the perfect wallpaper to reflect your unique style and create a stunning backdrop for your home.
              </p>
              <ul className="list-style-disc">
                <li className="mb-2 .text-theme-light">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Easy Application: Perfect for quick home makeovers.
                </li>
                <li className="mb-2 .text-theme-light">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Diverse Styles: Match any decor with our wide range.
                </li>
                <li className="mb-2 .text-theme-light">
                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                  Durable Options: Long-lasting and easy to maintain.
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <img src="/images/product/prd5.webp" alt="Curtain Fabrics" className="img-fluid rounded" />
            </div>
          </div>


        </div>
      </section>


      {/* Contact Section */}
      <section className="py-1 contactSection">
        <div className="container text-center">
          <h6 className="text-uppercase text-theme-light">Get in Touch</h6>
          <h2 className="fw-bold mb-1 text-theme-light responsive-main-heading">Contact Elly Decor</h2>
          <p className="mb-4 text-theme-light">
            We are here to assist you with all your home furnishing needs. Reach out to us anytime!
          </p>

          <div className="row text-start">
            <div className="col-lg-4 mb-4 text-center">
              <span className="h1Icon"><i className="fas fa-envelope"></i></span>
              <h4 className="text-theme-light">Email Us</h4>
              <p className="text-theme-light">
                For inquiries, please email us at{" "}
                <a href="mailto:info@ellydecor.com" className="text-theme-light">
                  info@ellydecor.com
                </a>
                . We aim to respond within 24 hours.
              </p>
            </div>
            <div className="col-lg-4 mb-4 text-center">
              <span className="h1Icon"><i className="fas fa-phone-alt"></i></span>
              <h4 className="text-theme-light">Call Us</h4>
              <p className="text-theme-light">
                You can reach us at <strong>+91 98214 95696</strong>. Our team is available to assist you during business hours.
              </p>
            </div>
            <div className="col-lg-4 mb-4 text-center">
              <span className="h1Icon"><i className="fas fa-map-marker-alt"></i></span>
              <h4 className="text-theme-light">Visit Us</h4>
              <p className="text-theme-light">
                Come see us at our store located at{" "}
                <strong>Shop No. 2, Block A, CLR Complex, Sector 149, Noida, Uttar Pradesh 201310, India</strong>.
                We look forward to welcoming you!
              </p>
            </div>
          </div>
        </div>
      </section>


    </>

  );
};

export default ProductCategories;
